import Widget, { WidgetVariant } from "@gx/dls/widget/Widget";

import { useEditSourceFormContext } from "@/pages/sources/components/edit/hooks";
import SourceArtifactContentTable from "@/pages/sources/components/edit/tabs/artifacts/components/SourceArtifactContentTable";

const EditSourceArtifacts = () => {
  const { state } = useEditSourceFormContext();

  return (
    <Widget variant={WidgetVariant.BASE} noPadding noHover fillWidth fillHeight>
      <SourceArtifactContentTable sourceId={state.source.id} />
    </Widget>
  );
};

export default EditSourceArtifacts;
